import React from 'react';
import {Breadcrumb, Divider, Row, Col, Calendar, Alert, List, Avatar} from 'antd';
import moment from 'moment';

class DashboardView extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            value: moment('2020-01-10'),
            selectedValue: moment('2020-01-10'),
        }
    }

    onSelectDate = value => {
        this.setState({
            value,
            selectedValue: value,
        });
    };

    onPanelChange = value => {
        this.setState({ value });
    };

    render(){
        const { value, selectedValue } = this.state;

        const data = [
            {
                title: 'Ant Design Title 1',
            },
            {
                title: 'Ant Design Title 2',
            },
            {
                title: 'Ant Design Title 3',
            },
            {
                title: 'Ant Design Title 4',
            },
        ];


        return(
            <div>
                <Row>
                    <Col span={6}>
                        <Breadcrumb style={{margin: '16px 0'}}>
                            <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <List
                        header={<h1> To Do List</h1>}
                        style = {{backgroundColor:'white'}}
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                                    title={<a href="https://ant.design">{item.title}</a>}
                                    description="Ant Design, a design language for background applications, is refined by Ant UED Team"
                                />
                            </List.Item>
                        )}
                    />
                </Row>
                <Divider/>
                <Row>
                    <Alert
                        message={`You selected date: ${selectedValue && selectedValue.format('YYYY-MM-DD')}`}
                    />
                    <Calendar value={value} onSelect={this.onSelectDate} onPanelChange={this.onPanelChange} style={{backgroundColor:'white'}}/>
                </Row>
            </div>
        );
    }
}







export default DashboardView